import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { SendSMSService } from './../send-sms.service';
import { StepIndicatorService, AccordionModel, PageLoaderService, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { UtilityService, AdobeAnalyticsService } from './../../../../lib/ng2-sapmp/src/providers';
import { MessageModel } from './../models/smsMessage.model';
import { FanModel } from './../../../models/fan/fan.model';
import { ENV } from 'config';

declare var ENV_VAR: any;

@Component({
  templateUrl: './review-message.component.html',
  styleUrls: ['./review-message.component.scss'],
  providers: [AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class ReviewMessageComponent implements OnInit {

  public pageJson: any;
  public inputList: Array<any>;
  public selectedList: Array<any>;
  public showError: boolean;
  private savedMessage: MessageModel;

  constructor(private messageService: SendSMSService,
    private stepIndicator: StepIndicatorService,
    private utilities: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    private breadcrumb: BreadCrumbService,
    private spinner: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private utilityService: UtilityService) {
    this.savedMessage = this.messageService.getMessageModel();
    let redirect = false;
    if (!this.savedMessage.message.length) {
      this.router.navigate(['accounts'], { relativeTo: this.route.parent });
      return;
    }
   // messageService.getPageJson().subscribe(json => {
    //  if (json) {
        this.pageJson = this.route.snapshot.data.pageData.sendMessagemessage;
        this.pageJson = this.pageJson['reviewJson'];
        //this.pageJson = Object.assign({}, json['reviewJson']);
        this.pageJson.messageText = this.savedMessage.message;
        this.pageJson.accountType = this.savedMessage.accountType;
        this.selectedList = [];
        let col;
        if (this.pageJson.accountType === 'allFans') {
          this.inputList = this.savedMessage.fanList;
          this.selectedList = this.messageService.filterSelected(this.inputList);
          col = this.pageJson.fanColumnDefinitions;
          if (this.selectedList.length === 1) {
            this.pageJson.gridHeader = 'Foundation account: <selected> ';
          } else {
          this.pageJson.gridHeader = 'Foundation accounts: <selected> ';
          }
        } else {
          this.inputList = this.savedMessage.ctnList;
          this.pageJson.fanSelectionStatus = 'Foundation account number: ' + this.savedMessage.selectedFan.fanId;
          if (!this.inputList) {
            redirect = true;
          } else {

            if (this.pageJson.accountType === 'allCTN') {
              this.inputList = this.messageService.toggleSelect(this.inputList);
            }
            this.selectedList = this.messageService.filterSelected(this.inputList);

            col = this.pageJson.ctnColumnDefinitions;
            this.pageJson.gridHeader = this.pageJson.accountType === 'allCTN' ? (this.selectedList.length === 1) ?
            ('Exclude ' + this.selectedList.length + ' wireless number') : ('Exclude ' + this.selectedList.length + ' wireless numbers') :
              '<selected> wireless numbers selected';
          }
        }

        if (this.selectedList.length > 5) {
          this.pageJson.accordion = [this.createAccordionModel()];
        }

        if (this.selectedList.length) {
          this.pageJson.gridOptions = this.messageService.createGridOptions(this.selectedList, col, this.pageJson.accountType, 3);
        } else if (this.pageJson.accountType !== 'allCTN') {
          redirect = true;
        }
        if (redirect) {
          this.router.navigate(['accounts'], { relativeTo: this.route.parent });
        } else {
          this.stepIndicator.setCurrentStep('account');
          this.stepIndicator.setCurrentStep('review');
          this.stepIndicator.setVisibility(true);
        }
      //}
    //});
  }


  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
     this.messageService.createPageLoadProperties('REVIEW', 'Review');
  }

  next = () => {
    this.adobeAnalyticsService.createAdobeEventProperties('SMS', 'SUCCESS', 'formSubmit',
    'BC_Device_SMS_Review_Submit', 'success', 'Success_Admit', 'Send message', 'Body', '/businessconsole/manageInventory');
    this.toggleList();
    if (this.pageJson.accountType === 'allFans') {
      this.savedMessage.fanList = this.inputList;
    } else {
      this.savedMessage.ctnList = this.inputList;
    }
    // Update the output Model
    this.messageService.setMessageModel(this.savedMessage);
    const selected = this.savedMessage.selectedFan;
    const postBody = {
      message: this.savedMessage.message,
      fanList: this.savedMessage.accountType !== 'allFans' ? [selected.fanId] :
        this.messageService.extractIds(this.savedMessage.fanList, 'fanId'),
      ctnList: undefined,
      accountType: this.savedMessage.accountType
    };
    if (this.savedMessage.ctnList) {
      postBody.ctnList = this.messageService.extractIds(this.savedMessage.ctnList, 'ctnNumber');
    }
    const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
    const isDisabled = impersonator && impersonator.id ? true : false;
    if (isDisabled) {
      (<HTMLInputElement>document.getElementById('review-message-btn')).disabled = true;
    } else {
      this.spinner.setPageLoaderStatus(false);
      this.messageService.postSMS(postBody).subscribe(success => {
        this.breadcrumb.removeLastBreadCrumb();
        const currentUrl = this.breadcrumb.getLastUrlFromBreadCrumb().routerLink;
        sessionStorage.setItem('smsSent', 'true');
        this.spinner.setPageLoaderStatus(true);
        this.router.navigate([currentUrl]);
        // Start Adobe Analytics Starts
        this.adobeAnalyticsService.createAdobeEventProperties('SMS', 'SUCCESS', 'formResponse',
        'BC_Device_SMS_Review_Submit', 'success', 'Success_Admit', 'Send message', 'Body', '/businessconsole/manageInventory');
        // Ends
      }, (err) => {
        this.showError = true;
        this.pageJson.cta.next = 'Retry';
        this.toggleList();
        this.spinner.setPageLoaderStatus(true);
        this.messageService.setPageError(this.pageJson.error);
        // Start Adobe Analytics Starts
        this.adobeAnalyticsService.createAdobeEventProperties('SMS', 'FAILURE', 'FormResponse', 'BC_Device_SMS_Review_Submit',
        'Unable to send sms, please try after some time', 'Failure_user', 'Send message', 'Body', '/businessconsole/sendMessage/review');
        // Ends
      });

    }
  }

  back(route) {
    this.pageJson.cta.next = 'Send message';
    this.messageService.setPageError('');
    if (this.showError) {
      this.toggleList();
    }
    this.router.navigate([route], { relativeTo: this.route.parent });
  }

  createAccordionModel() {
    const accordionModel = new AccordionModel();
    accordionModel.id = 'sendSMS';
    accordionModel.isActive = false;
    if (this.pageJson.accountType === 'allFans') {
      accordionModel.category = this.selectedList.length + ' Foundation account numbers';
      accordionModel.ariaLabel = {
        'expand': 'Show list of foundation accounts.',
        'collapse': 'Hide list of foundation accounts.'
      };
    } else {
      accordionModel.category = this.pageJson.accountType === 'allCTN' ? 'Exclude ' + this.selectedList.length + ' wireless numbers' :
        this.selectedList.length + ' wireless numbers selected';
      accordionModel.ariaLabel = {
        'expand': 'Show list of wireless numbers.',
        'collapse': 'Hide list of wireless numbers.'
      };
    }
    return accordionModel;
  }

  onSelectChange(e: any, accountType: string) {
    const filterBy = accountType === 'allFans' ? 'fanId' : 'ctnNumber';
    this.selectedList = this.messageService.filterSelected(e.griddata);
    let title = this.selectedList.length + (this.pageJson.accountType === 'allFans' ?
    ((this.selectedList.length === 1) ? ' Foundation account numbers' : ' Foundation account numbers' )
      : ((this.selectedList.length === 1) ? 'Wireless number selected' : 'Wireless numbers selected')) ;
    if (this.pageJson.accountType === 'allCTN') {
      title = (this.selectedList.length === 1) ?
      ('Exclude ' + this.selectedList.length + ' wireless number') : ('Exclude ' + this.selectedList.length + ' wireless numbers');
    }
    if (this.pageJson.accordion) {
      this.pageJson.accordion[0].category = title;
    }

    this.inputList = this.inputList.filter(item => {
      if (item[filterBy] === e.data[filterBy]) {
        item = e.data;
      }
      return item;
    });
  }

  toggleList() {
    if (this.pageJson.accountType === 'allCTN') {
      this.inputList = this.messageService.toggleSelect(this.inputList);
    }
  }
}
